module.exports = __webpack_public_path__ + "img/kleisma3-m@2.924f92fa.jpg";